import { X } from 'lucide-react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { customerSchema } from '../lib/schemas'

export default function CustomerForm({ onSubmit, onCancel }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(customerSchema),
    defaultValues: {
      customer_name: '',
      tenant_id: '',
      tier: 'standard',
      requests_per_hour: 1000,
      requests_per_day: 10000,
    },
  })

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add New Customer</h2>
          <button onClick={onCancel} className="close-button">
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="customer-form">
          <div className="form-group">
            <label htmlFor="customer_name">Customer Name *</label>
            <input
              type="text"
              id="customer_name"
              placeholder="e.g., Contoso Inc"
              {...register('customer_name')}
            />
            {errors.customer_name && (
              <small style={{ color: 'var(--danger)' }}>{errors.customer_name.message}</small>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="tenant_id">Tenant ID</label>
            <input
              type="text"
              id="tenant_id"
              placeholder="e.g., abc12345-1234-1234-1234-abc123456789"
              {...register('tenant_id')}
            />
            {errors.tenant_id ? (
              <small style={{ color: 'var(--danger)' }}>{errors.tenant_id.message}</small>
            ) : (
              <small>The customer's Azure AD tenant ID (auto-generated if blank)</small>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="tier">Subscription Tier</label>
            <select id="tier" {...register('tier')}>
              <option value="basic">Basic (500 req/hour)</option>
              <option value="standard">Standard (1000 req/hour)</option>
              <option value="premium">Premium (5000 req/hour)</option>
            </select>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="requests_per_hour">Requests per Hour</label>
              <input
                type="number"
                id="requests_per_hour"
                min="100"
                max="10000"
                {...register('requests_per_hour')}
              />
              {errors.requests_per_hour && (
                <small style={{ color: 'var(--danger)' }}>{errors.requests_per_hour.message}</small>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="requests_per_day">Requests per Day</label>
              <input
                type="number"
                id="requests_per_day"
                min="1000"
                max="100000"
                {...register('requests_per_day')}
              />
              {errors.requests_per_day && (
                <small style={{ color: 'var(--danger)' }}>{errors.requests_per_day.message}</small>
              )}
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={onCancel} className="btn-secondary">
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Creating…' : 'Create Customer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
